import PropTypes from 'prop-types';
import React from 'react';
import {
  FormGroup,
  InputGroup,
  ButtonToolbar,
  Button,
  ControlLabel,
  FormControl,
  HelpBlock,
  Table,
} from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn, BootBootstrapButton } from 'react-bootstrap-table';
import moment from 'moment';


class HotelsListTable extends React.Component {
    constructor(props) {
    super(props);
    this.state = {
      hotelsData: [],
      hotel_name: '',
      google_place_id: '',
      isDisabled: true,
      hotelAddress: '',
      additionalTax: 0,
      resortFee: 0
    }
    this.handleHotelSelection = this.handleHotelSelection.bind(this);
    this.handleHotelSelectionAddress = this.handleHotelSelectionAddress.bind(this);
  }
  componentDidMount(){
    let hotelsList = this.props.hotels;
    let hotelsData = [];
    if(this.props.isAdvanceSearch){
       hotelsList.forEach((hotel)=>{
        if(hotel.place_id){
            hotelsData.push({
            id: hotel.id,
            hotel_name: hotel.name,
            google_place_id: hotel.place_id,
            hotel_address: hotel.formatted_address,
            additional_tax: hotel.additional_tax,
            resort_fee: hotel.resort_fee
          })
        }
      })
    }else{
      hotelsList.forEach((hotel)=>{
        if(hotel.google_place_id){
            hotelsData.push({
            id: hotel.id,
            hotel_name: hotel.name,
            google_place_id: hotel.google_place_id,
            hotel_address: hotel.address,
            additional_tax: hotel.additional_tax,
            resort_fee: hotel.resort_fee
          })
        }
    })
    }
    this.setState({
      hotelsData: hotelsData
    })
  }
  handleHotelSelection = (e, row) => {
    this.setState({
      google_place_id: row.google_place_id,
      hotel_name: row.hotel_name,
      hotelAddress: row.hotel_address,
      isDisabled: false,
      additionalTax: row.additional_tax,
      resortFee: row.resort_fee
    })
  }
  handleHotelSelectionAddress(){
    this.props.handleLocationSelect(this.state.hotel_name, this.state.google_place_id, this.state.hotelAddress, this.state.additionalTax, this.state.resortFee)
  }
  formatHotelAddress = (row, rowIndex) => {  
    return (
    <span title={row}> {row} </span>
    )
 }
  radioBtnFormatter = (cell, row) => {
    let name = 'hotelData'
    return (
      <input type='radio' name={name} onChange={(e) => this.handleHotelSelection(e, row)} />
    )
  }
  render() {
    return (
      <div
        className="row"
      >
        <ButtonToolbar style={{ float: 'right', margin:'15px'}}>
            <Button
              bsStyle="success"
              onClick={this.handleHotelSelectionAddress}
              disabled={this.state.isDisabled}
              >
              OK
            </Button>
          </ButtonToolbar>
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 hotels-list-table">
          <BootstrapTable
            data={this.state.hotelsData}
            striped
          >
            <TableHeaderColumn dataField="google_place_id" width="12" dataFormat={this.radioBtnFormatter} dataAlign="center"></TableHeaderColumn>
            <TableHeaderColumn dataField="id" isKey hidden>ID</TableHeaderColumn>
            <TableHeaderColumn dataField="hotel_name" width="100" headerAlign="center" dataAlign="left">{this.props.tableHeader ? this.props.tableHeader : "Hotel Name"}</TableHeaderColumn>
            <TableHeaderColumn dataField="hotel_address" width="100" headerAlign="center" dataAlign="left" dataFormat={this.formatHotelAddress}>Address</TableHeaderColumn>
          </BootstrapTable>
        </div>
      </div>
    );
  }
}


HotelsListTable.propTypes = {

};

export default HotelsListTable;



// WEBPACK FOOTER //
// src/routes/tours/components/HotelsListTable.js